<template>
	<div id="message" class="tw-flex tw-flex-col">
        <div class="tw-flex tw-w-full" :class="{'message-status-sending': error}">
            <img :src="message.avatar_url" class="tw-mr-3 tw-rounded-full message-gravatar"/>
            <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
                <div class="tw-flex tw-items-center">
                    <p class="message-title tw-font-semibold">{{ message.name }}</p>
                    <p v-if="is_host" class="message-tag">Host</p>
                </div>
                <p class="message-body tw-break-words" v-html="message.body" />
            </div>
            <span class="message-title">{{ formatted_date }}</span>
        </div>
        <div v-if="message.error" class="message-resend">
            <div @click="resendMessage" :class="{'message-status-sending': error}">
                <i class="fa fa-exclamation-circle tw-mr-1"></i>
                {{ $t('live.resend_message') }}
            </div>
            <i @click="deleteMessage" class="fa fa-trash tw-text-xs tw-mr-2" :class="{'message-status-sending': error}" ></i>
        </div>
	</div>
</template>

<script>
export default {
	name: "ChatMessage",
	props: {
		message: {
			required: true,
			type: Object,
			default: {
				id: 1,
				name: 'Hendrik Henderson',
				user_id: 1,
				created_at: '12-01-2022 18:00',
				body: 'Hello I am a message',
				thread_id: 1,
				new: false,
				not_send: true,
				fake_thread_id: 1,
                error: false,
			}
		},
		thread: {
			required: true,
			type: Object,
		},
		hosts: {
			required: true,
			type: Array
		},
        livekit_local_participant: {
          required: true
        },
	},
    computed: {
        is_host() {
            return this.hosts.includes(this.message.user_id);
        },
        error() {
            return this.message.error || this.message.not_send;
        },
        formatted_date() {
            // .replace is used to have a valid date in safari
            const new_date = new Date(this.message.created_at.replace(/-/g, "/"));
            const minutes = new_date.getMinutes() < 10 ? '0' + new_date.getMinutes() : new_date.getMinutes();
            return new_date.getHours() + ':' + minutes;
        },
    },
	methods: {
        deleteMessage() {
            Message.delete(this.message.id);
        },
        resendMessage(){
            this.$emit('resendMessage', this.message);
        },
    },
}
</script>

<style lang='scss' scoped>
.message-title {
	font-size: 0.714rem;
	color: #868E96;
}
.message-body {
	font-size: 0.929rem;
}
.message-gravatar {
	width: 1.714rem;
	height: 1.714rem;
}
.message-status-sending {
	opacity: 0.4;
}

.message-resend {
    @apply tw-flex tw-justify-between tw-mt-2;

    div {
        @apply tw-ml-10 tw-text-red-500;
        font-size: 0.714rem;
    }

    div:hover {
        cursor: pointer;
        animation: fadeIn 0.15s forwards;
        transition-timing-function: ease-out;
    }

    i:hover{
        cursor: pointer;
        animation: fadeIn 0.15s forwards;
        transition-timing-function: ease-out;
    }
}

@keyframes fadeIn {
    0% { opacity: 0.4; }
    100% { opacity: 1; }
}

.message-tag {
	font-size: 0.714rem;
	color: white;
	padding: 2px 4px;
	background-color: #2196F3;
	border-radius: 4px;
	margin-left: 8px;
}
</style>
